module.exports = __webpack_public_path__ + "cn.svg?b69b626264f1942426aa4874a2a9c70a";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/cn.svg
// module id = 1030
// module chunks = 27